import { QFilter, TASK_CHOICE_MAPPING, TASK_KIND_MAPPING, TaskKind } from '@/types';
import { SearchTreeNode } from '@/types/searchTreeTypes';
import { DomainCode } from '@australiangreens/ag-internal-components';
import { logger } from '@/util';
import callBackendApi from './call';

export const updateTasks = async (
  token: string,
  values: {
    qFilter: QFilter;
    electionId: number;
    taskKindType: TaskKind;
    levelOfInterest: string;
    notes: string;
    domainCode: DomainCode;
  }
) => {
  logger.debug('updateTasks() called', {});

  const data = await callBackendApi({
    token,
    method: 'post',
    endpoint: '/tasks',
    data: values,
  });

  return data;
};

export type UpdateTasksAdvData = {
  tree: SearchTreeNode;
  domainCode: DomainCode;
  electionId: number;
  taskKindType: keyof typeof TASK_KIND_MAPPING;
  levelOfInterest: keyof typeof TASK_CHOICE_MAPPING;
  notes?: string;
};

// [LIST-680]
export const updateTasksAdv = async (token: string, data: UpdateTasksAdvData) =>
  callBackendApi({
    token,
    method: 'post',
    endpoint: '/tasks/adv',
    data,
  });
